import ResetRulesCell from './ResetRulesCell'
import PtoRulesMixin from './PtoRulesMixin'

class PtoResetRulesCell extends ResetRulesCell {
    constructor() {
        super()

        this.mixin = new PtoRulesMixin()
    }
}

export default PtoResetRulesCell



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/PtoResetRulesCell.js